import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useRouter } from 'next/router'

import Login from '~/auth/pages/Login.page'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import GuestGuard from '~/components/GuestGuard'
import { COMMON_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import appConfig from '~/config/app'
import AppLoginPage from '~/auth/pages/AppLogin'

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'welcome',
      'logIn',
      'authenticate',
      'fields',
      'generics',
      'errors',
      'footer',
      'registerAccount',
      'menu',
    ])),
  },
})

const LoginPage: NextPage = () => {
  const { t } = useTranslation('logIn')
  const router = useRouter()
  const redirect = router.query.from as string | undefined

  const isMobileApp = appConfig.isMobileApp

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} noindex title={usePageTitle(t('title'))} />

      <GuestGuard redirect={redirect}>{isMobileApp ? <AppLoginPage /> : <Login />}</GuestGuard>
    </div>
  )
}

export default LoginPage
